import { render, staticRenderFns } from "./StageText.vue?vue&type=template&id=23fe3b8c&scoped=true&"
import script from "./StageText.vue?vue&type=script&lang=ts&"
export * from "./StageText.vue?vue&type=script&lang=ts&"
import style0 from "./StageText.vue?vue&type=style&index=0&id=23fe3b8c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23fe3b8c",
  null
  
)

export default component.exports